'use client';

import { useModals } from '@/contexts/ModalContext';
import { useTranslations } from 'next-intl';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type Props = {
  onOk: () => void;
};

export const AfterSupportModal: React.FC<Props> = ({ onOk }) => {
  const modals = useModals();
  const t = useTranslations('modals');

  const onClose = () => {
    onOk();
    modals.close(`after-support-modal`);
  };
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('afterSupport.request_send')}</DialogTitle>
        </DialogHeader>

        <Button
          variant='outline'
          onClick={onClose}
          className='h-auto text-m font-medium py-[10px] w-full text-primary-green-day bg-transparent hover:bg-transparent rounded-[12px] border-primary-green-day'
        >
          {t('afterSupport.button_ok')}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
